import { Box, CardContent, Grid } from "@mui/material";
import { MprcButton, MprcCard, MprcFormSubHeader, MprcLink, MprcTypography } from "components";
import { ButtonCancel } from "components/buttons";
import { useSession } from "providers/SessionProvider";
import { Trans, useTranslation } from "react-i18next";
import { SessionService } from "services/sessionService";

interface IProps {
    onClose: (result: "cancel" | "skipped" | "continue") => void;
}

export const TwoFactorAppConnect = (props: IProps) => {
    const { t } = useTranslation();
    const { onClose } = props;
    const { config: { twoFactorOptions } } = useSession();

    return (
        <Grid container direction="column" justifyContent="center" alignItems="center" spacing={2} >
            <Grid size="grow">
                <img
                    src={SessionService.current.appImages.highlightImageUrl}
                    width="360"
                />
            </Grid>
            <Grid size="grow">
                <MprcCard sx={{ maxWidth: 500 }}>
                    <CardContent>
                        <div>
                            <MprcFormSubHeader
                                title={
                                    <center>
                                        <Box sx={{ minHeight: 32 }}>
                                            {t("Auth.Login.2FA.APP.Connect.Title")}
                                        </Box>
                                    </center>
                                }

                                subtitle={
                                    <MprcTypography variant="subtitle1">
                                        <center>
                                            {t("Auth.Login.2FA.APP.Connect.Subtitle")}
                                        </center>
                                    </MprcTypography>
                                }
                                margin="normal"
                            />
                            <MprcTypography variant="subtitle1">
                                <p>{t("Auth.Login.2FA.APP.Connect.Body1")}: <MprcLink href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2" target="_blank">GOOGLE AUTHENTICATOR</MprcLink> {t("shared:Literal.Or")} <MprcLink href="https://play.google.com/store/apps/details?id=com.azure.authenticator" target="_blank">MICROSOFT AUTHENTICATOR</MprcLink></p>
                                <p><Trans t={t} i18nKey="Auth.Login.2FA.APP.Connect.Body2" /></p>
                                <p><Trans t={t} i18nKey="Auth.Login.2FA.APP.Connect.Body3" /></p>
                            </MprcTypography>
                            <Grid container justifyContent="space-evenly" alignItems="center" spacing={2} style={{ marginTop: 30 }}>
                                {
                                    <Grid>
                                        {
                                            twoFactorOptions?.allowSkipAppAuthenticator === true
                                                ? <MprcButton
                                                    color="muted"
                                                    variant="contained"
                                                    onClick={() => onClose("skipped")}
                                                >
                                                    <span>{t("Auth.Login.2FA.APP.Connect.SkipSetupText")}</span>
                                                </MprcButton>
                                                : <ButtonCancel
                                                    variant="contained"
                                                    onClick={() => onClose("cancel")}
                                                />
                                        }
                                    </Grid>
                                }
                                <Grid>
                                    <MprcButton
                                        color="primary"
                                        variant="contained"
                                        onClick={() => onClose("continue")}
                                    >
                                        <span>{t("Auth.Login.2FA.APP.Connect.ContinueText")}</span>
                                    </MprcButton>
                                </Grid>
                            </Grid>
                        </div>
                    </CardContent>
                </MprcCard>
            </Grid>
        </Grid>
    );
};